import axios from 'axios'

export default {
  codeValidation(code) {
    return axios.get(`/api/auth/signup/${code}`)
  },
  signUp(formData) {
    return axios.post('/api/auth/signup', formData)
  }
}
